import { withInstall, withNoopInstall } from '@zoryn/utils'
import Tabs from './src/tabs'
import TabPane from './src/tab-pane.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZTabs: SFCWithInstall<typeof Tabs> & {
  TabPane: typeof TabPane
} = withInstall(Tabs, {
  TabPane,
})
export const ZTabPane: SFCWithInstall<typeof TabPane> =
  withNoopInstall(TabPane)
export default ZTabs

export * from './src/tabs'
export * from './src/tab-bar'
export * from './src/tab-nav'
export * from './src/tab-pane'
export * from './src/constants'
